import { GetUserAchLimitsModelDto as BoUserAchLimitsModelDto } from '@treasury/api/bo';
import { GetUserAchLimitsModelDto as ConsumerUserAchLimitsModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';
import { CompanyUserAchCompanyLimit } from './company-user-ach-company-limit.entity';

const defaultCompanyUserAchLimits: BoUserAchLimitsModelDto = {
    userProductLimit: {
        initiationLimit: 0,
        approvalLimit: 0,
    },
    pendingUserProductLimit: {
        initiationLimit: 0,
        approvalLimit: 0,
    },
    userAchCompanies: [],
    productDailyLimit: 0,
};

export class CompanyUserAchLimits extends DomainEntity<
    BoUserAchLimitsModelDto | ConsumerUserAchLimitsModelDto
> {
    public userProductLimit = this.dto.userProductLimit;

    public get productInitiationLimit() {
        return this.dto.userProductLimit?.initiationLimit;
    }

    public get productApprovalLimit() {
        return this.dto.userProductLimit?.approvalLimit;
    }

    public get pendingProductInitiationLimit() {
        return this.dto.pendingUserProductLimit?.initiationLimit;
    }

    public set pendingProductInitiationLimit(value: number | undefined) {
        if (!this.dto.pendingUserProductLimit) {
            this.dto.pendingUserProductLimit = {};
        }
        this.dto.pendingUserProductLimit.initiationLimit = value;
    }

    public get pendingProductApprovalLimit() {
        return this.dto.pendingUserProductLimit?.approvalLimit;
    }

    public set pendingProductApprovalLimit(value: number | undefined) {
        if (!this.dto.pendingUserProductLimit) {
            this.dto.pendingUserProductLimit = {};
        }
        this.dto.pendingUserProductLimit.approvalLimit = value;
    }

    public get productDailyLimit() {
        return this.dto.productDailyLimit;
    }

    public get userAchCompanies(): CompanyUserAchCompanyLimit[] {
        return (this.dto.userAchCompanies ?? []).map(
            company => new CompanyUserAchCompanyLimit(company)
        );
    }

    public createDefault(): this {
        return new CompanyUserAchLimits(defaultCompanyUserAchLimits) as this;
    }
}
